
import React from 'react';
import { Users, HeartHandshake, BarChart, Presentation } from "lucide-react";
import ServiceCard from "@/components/ServiceCard";

const ConsultingServices = () => {
  return (
    <section className="section-spacing bg-joerg-50">
      <div className="container">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <span className="inline-block text-primary font-medium mb-4 px-3 py-1 bg-primary/10 rounded-full text-sm animate-fade-in">
            Meine Leistungen
          </span>
          <h2 className="text-center animate-fade-in mb-6" style={{ animationDelay: '100ms' }}>
            Strategien für zukunftsfähige Unternehmensführung
          </h2>
          <p className="text-joerg-600 text-lg leading-relaxed animate-fade-in" style={{ animationDelay: '200ms' }}>
            Entdecken Sie mein Portfolio an Dienstleistungen, die auf die konkreten Herausforderungen 
            moderner Führung zugeschnitten sind – für messbare Ergebnisse.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <ServiceCard
            title="Executive Coaching mit emotionaler Intelligenz"
            description={
              <>
                Strategische Führungsbegleitung für Führungspersönlichkeiten, die ihre emotionale Intelligenz stärken und authentischer führen möchten. Entwickeln Sie einen Führungsstil, der nachweislich Mitarbeiterbindung und Innovation fördert. Entdecken Sie auch unser{' '}
                <a 
                  href="/outdoor-coaching" 
                  className="text-primary hover:text-primary-600 underline decoration-2 underline-offset-2 transition-colors"
                >
                  Outdoor-Coaching am Rothsee
                </a>
                {' '}für neue Perspektiven.
              </>
            }
            icon={<Users className="h-5 w-5" />}
            buttonText="Gespräch vereinbaren"
            buttonUrl="/kontakt"
            delay={0}
          />
          
          <ServiceCard
            title="Team-Entwicklung"
            description="Maßgeschneiderte Workshops und Prozessbegleitung für Teams, die ihre Zusammenarbeit verbessern und Potenziale freisetzen möchten. Konflikte konstruktiv lösen und gemeinsame Ziele erreichen – für bis zu 30% höhere Teamleistung."
            icon={<HeartHandshake className="h-5 w-5" />}
            buttonText="Gespräch vereinbaren"
            buttonUrl="/kontakt"
            delay={150}
          />
          
          <ServiceCard
            title="Strategische Führungsbegleitung"
            description="Begleitung bei der Entwicklung nachhaltiger Geschäftsstrategien, die wirtschaftlichen Erfolg mit sozialer Verantwortung verbinden. Katalysator-Führung verbindet Strategie, Menschlichkeit und aktivem Wandel für messbar bessere Ergebnisse."
            icon={<BarChart className="h-5 w-5" />}
            buttonText="Gespräch vereinbaren"
            buttonUrl="/kontakt"
            delay={300}
          />
          
          <ServiceCard
            title="Impulsvorträge"
            description="Inspirierende Vorträge zu Themen wie:
• 'Katalysator-Führung: Menschen befähigen, Ergebnisse steigern'
• 'Emotionale Intelligenz als wirtschaftlicher Faktor'
• 'Resiliente Führung in volatilen Märkten'
• 'Balanced Leadership: Die Integration von Ratio und Emotion'"
            icon={<Presentation className="h-5 w-5" />}
            buttonText="Gespräch vereinbaren"
            buttonUrl="/kontakt"
            delay={450}
          />
        </div>
      </div>
    </section>
  );
};

export default ConsultingServices;
